import { compose as r } from "../../../tailwind-buddy-interface.js";
const a = r({
  slots: {
    root: ""
  },
  variants: {
    /** Sets the component size. By default, it matches the parent `Card` size (`cardSize` value), but it can also be set independently. */
    size: {
      sm: {
        root: ["px-250", "py-200"]
      },
      md: {
        root: ["px-350", "py-300"]
      },
      cardSize: {
        root: [
          "group-[.sm]/card:px-250",
          "group-[.sm]/card:py-200",
          "group-[.md]/card:px-350",
          "group-[.md]/card:py-300"
        ]
      }
    }
  },
  compoundVariants: [],
  responsiveVariants: [],
  defaultVariants: {
    size: "cardSize"
  }
})();
export {
  a as cardBodyVariants
};
